import { render, staticRenderFns } from "./reassign-purchase-order.vue?vue&type=template&id=15631cd0&scoped=true"
import script from "./reassign-purchase-order.vue?vue&type=script&lang=ts"
export * from "./reassign-purchase-order.vue?vue&type=script&lang=ts"
import style0 from "./reassign-purchase-order.vue?vue&type=style&index=0&id=15631cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15631cd0",
  null
  
)

export default component.exports